const routesName = {
    home:"Inicio"
}

export default routesName;